/* Flagship reveal-on-scroll. Progressive + fail-safe: content is NEVER
   left hidden. If IntersectionObserver is missing, .fl-js is never set
   (see theme.liquid) so CSS leaves everything visible. */
(function () {
  function reveal(el) { el.classList.add('is-in'); }

  /* Gate all motion when the OS/browser requests it (WCAG 2.3 / build spec). */
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window) || prefersReduced) {
    document.querySelectorAll('.fl-reveal').forEach(reveal);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  function observeAll() {
    document.querySelectorAll('.fl-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
  }

  function failsafe() {
    /* Anything already in (or above) the viewport that the observer didn't
       catch gets revealed; below-fold sections keep their scroll reveal. */
    document.querySelectorAll('.fl-reveal:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < (window.innerHeight || 800) + 40) reveal(el);
    });
  }

  function boot() { observeAll(); setTimeout(failsafe, 900); }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', observeAll);
})();
